module.exports = __webpack_public_path__ + "img/bubinga-swatch.03098fe3.png";